import {
  Component,
  ViewChild,
  OnInit,
  TemplateRef,
  AfterViewInit,
  Pipe,
  PipeTransform,
} from "@angular/core";
import { Router } from "@angular/router";
import {
  FormGroup,
  FormBuilder,
  FormControl,
} from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { NavigationService } from "../navigation.service";
import { NavLink } from "../navigation.models";
import { of, Subject, Subscription, takeUntil } from "rxjs";
import {
  ColumnMode,
  DatatableComponent,
  SelectionType,
} from "@swimlane/ngx-datatable";
import { AlertService } from "../../alert/alert.service";
import { MatTableDataSource } from "@angular/material/table";
@Component({
  selector: "app-navigation-link",
  templateUrl: "./navigation-link.component.html",
  styleUrls: ["./navigation-link.component.scss"],
})
export class NavigationLinkComponent implements OnInit , AfterViewInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  dataSource = new MatTableDataSource<any>([]);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild("colTemplate") Actiontemplate: TemplateRef<any>;
  @ViewChild(DatatableComponent) table: DatatableComponent;

  public navlinkform: FormGroup;
  enableSummary = false;
  summaryPosition = "top";
  selected = [];
  SelectionType = SelectionType;
  loadingIndicator = true;
  reorderable = true;
  public displayedColumns = [
    "title",
    "linkText",
    "linkOrder",
    "parentName",
    "actions",
  ];
  public OrignalData: any[] = [];
  public Navlink: boolean = false;
  public isEditing: boolean = false;
  subscription: Subscription;
  public ResponseData: NavLink;
  ActiveNav: boolean = false;
  TableData: any;
  NgxData: any;
  ngxSettings: any;
  isCopyNeeded: boolean = true;
  tableshow: boolean = false;
  data: any | null = null;
  public avail: boolean = false;
  public FieldData: any;
  public OnCancel: boolean = false;
  IsDeleted: boolean;
  // isAdd:boolean=true;

  private _onDestroy = new Subject<void>();
  public parentflt: any;
  totalCount = 0;
  getBillingData: any;
  statusList = [];
  currentTempData: any;
  isTableSettingsShow = true;
  showCheckConfirmDialog: boolean;
  hidePage: boolean;
  widgetData: any[] = [];
  pages = 10;
  pageSizee = 10;
  page = 1;

  currentPage: number;

  checkedt: boolean = false;
  Source = [
    {
      id: "ERP",
      name: "ERP",
    },
    {
      id: "LCP",
      name: "LCP",
    },
  ];
  public menuflt: any;
  public data1: NavLink[] = [];
  public pageLimitOptions = [
    { value: 2 },
    { value: 5 },
    { value: 10 },
    { value: 15 },
    { value: 20 },
    { value: 25 },
    { value: 50 },
    { value: 100 },
    { value: 200 },
    { value: 300 },
    { value: 400 },
    { value: 500 },
    { value: 1000 },
  ];
  activeInactiveSearch: boolean = false;
  public ParentListCtrl: FormControl = new FormControl();
  showEdit: boolean = true;
  showDelete : boolean = false;
  showEdits : boolean = false;
  Navdata: any;
  constructor(
    public fb: FormBuilder,
    public router: Router,
    public dialog: MatDialog,
    public navservice: NavigationService,
    public alertService :AlertService,
  ) {
    this.subscription = this.navservice.closesub$.subscribe((val: any) => {
      this.ResponseData = val as NavLink;
      this.closee();
    });
    this.navlinkform = this.fb.group({
      title: [""],
      parentName: [""],
      source: [""],
    });
   
  }

  ngOnInit(): void {
    //this.GetAllNavLink();

    //. this.navlinkform.get("source").patchValue("LCP");
    this.ParentListCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe((val) => {
        this.parentflt = this.searchParentList(val);
      });
    this.GetParentNavLink();
  }
  openSideNav() {
    // this.myNav.open();
  }

  closeSideNav() {
    // this.myNav.close();
    // this.sharedservice.opencloseleftNav(true);
  }
  addNavLink(nav: any) {
    this.Navdata = new NavLink();
    this.Navdata = nav;
    this.Navlink = true;
    this.isEditing = true;

  }
  closeForm(data:any){
    this.isEditing = false;
    this.Navlink = false;
  }
  closee() {
    if (this.ResponseData != null) {
      if (
        this.ResponseData.Isdialogclosed == true &&
        this.ResponseData.Isdialog == false
      ) {
        this.isEditing = false;
        this.Navlink = false;
        this.GetSearchData();
      }
    }
  }


  onDismiss() {
    this.OnCancel = true;
    this.closeSideNav();
  }
 

  GetAllNavLink(title?: undefined, menu?: undefined, source?: undefined) {
    this.isCopyNeeded = true;
    let obj = {
      Title: title ? title : null,
      ParentName: menu ? menu : null,
      Source: source ? source : "LCP",
      page: this.page,
      pageSize: this.pageSizee,
      IsDeleted: this.activeInactiveSearch,
    };
    this.navservice.listNavLinkData(obj).subscribe((data) => {
      if (data) {
        let Data: any = data;
        this.dataSource.data = Data;
        this.resultlength=Data.length
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

      }
      
    });
  }

 
  GetParentNavLink() {
    let obj = {};
    this.navservice.listParentNavLinkData(obj).subscribe((data) => {
      if (data) {
        this.parentflt = data as Array<NavLink>;
        this.data1 = this.parentflt;
      }
    });
  }
  searchParentList(value: string) {
    let filter = value.toLowerCase();
    this.menuflt = this.data1;
    return this.menuflt.filter((n: { title: string; }) => n.title.toLowerCase().includes(filter));
  }
  ClearSearch() {
    this.page = 1;
    if (this.pageSizee == 10) {
      this.pages = this.page * 10;
    }
    this.navlinkform.patchValue({ title: "" });
    this.navlinkform.patchValue({ parentName: "" });
    this.navlinkform.patchValue({ source: "LCP" });
    this.GetAllNavLink();
  }
  GetSearchData() {
    //
    let title =this.navlinkform.get("title")
    let menu = this.navlinkform.get("parentName")
     this.GetAllNavLink(title?.value, menu?.value, undefined);
  }

  GetInActiveRecords(event: any) {
    this.ActiveNav = event.checked;
    this.page = 1;
    if (this.pageSizee == 10) {
      this.pages = this.page * 10;
    }
    if (event.checked) {
      this.activeInactiveSearch = true;
      this.showEdit = false;
      this.GetSearchData();
    } else {
      this.activeInactiveSearch = false;
      this.showEdit = true;
      this.GetSearchData();
    }
  }
  updateinactive(event:any, index:any, activityStatus:any) {
    event["isDeleted"] = activityStatus.checked == true ? true : false;
    
        this.navservice.UpdateNavLink(event).subscribe(
          (data) => {
            if (this.ActiveNav === false) {
              this.GetSearchData();
              this.alertService.success("Inactive Successfully.");
            } else {
              this.GetSearchData();
              this.alertService.error("Active Successfully.");
            }
          },
          (error) => {
            this.alertService.error(
              "Navigation Link update Error"
            );
          }
        );
  }
  rows: any[] = [];
  columns: any[] = [];
  ColumnMode = ColumnMode;
 
  getJson() {
    let flds = JSON.parse(this.FieldData.tableFields);

    flds.forEach((element: { type: string; label: string; click: () => void; color: string; }) => {
      if (element.type == "button" && element.label == "Cancel") {
        element.click = this.onDismiss;
        element.color = "warn";
      }
    });
    of(flds).subscribe((data) => {
      // this.fields = data;
      this.data = this.NgxData[0];
    });
  }

  
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.GetAllNavLink();

  }


  currentPageIndex: number = 0;
  pageIndex: number = 1;
  pageSize: number = 5;
  resultlength = 0;
  
  getDatas(event: any) {
    if (event.pageSize != this.pageSize) {
      this.currentPageIndex = 0;
      this.currentPage = this.pageIndex
      this.pageSize = event.pageSize;


    }
    else if (event.previousPageIndex < event.pageIndex) {
      this.currentPageIndex = event.pageIndex;
      this.currentPage = event.pageIndex + 1;
      this.pageSize = event.pageSize;

    }
    else if (event.previousPageIndex > event.pageIndex) {
      this.currentPageIndex = event.pageIndex;
      this.currentPage = event.previousPageIndex - 1;
      this.pageSize = event.pageSize;

    }
    else {
      this.currentPage = event.pageIndex + 1;
      this.pageSize = event.pageSize;
    }
  }
}@Pipe({ name: 'removeLeadingSlash' })
export class RemoveLeadingSlashPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    return (value || '').replace(/^\//, '');
  }
}
